import { css } from "@emotion/react";

export const expansionNodeStyles = {
  expansionListItem: css({
    paddingLeft: 0,
    // matches MuiSelect
    paddingRight: 7,
  }),
  link: css({
    color: "rgb(191, 191, 191)",
    "&:hover, &:focus": {
      color: "white",
      textDecoration: "underline",
    },
  }),
};
